import { useTranslation } from "react-i18next";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { OrganizationUsageConfig } from "features/usage-config/components/organization-usage-config";
import { UsageConfigCard } from "features/usage-config/components/usage-config-card";
import { USAGE_LIMITS_I18N } from "features/usage-config/constants/usage-meters";

const T = USAGE_LIMITS_I18N;

/** A platform admin configures the tenant and every organization. The route lets
 * nobody else in. */
export const UsageConfigPage = () => {
  const { t } = useTranslation();

  return (
    <main className="flex h-full flex-col gap-4 p-6">
      <div>
        <h1 className="text-xl font-semibold md:text-2xl">{t(T.TITLE)}</h1>
        <p className="text-sm text-muted-foreground">{t(T.PAGE_SUBTITLE)}</p>
      </div>

      <Tabs defaultValue="tenant" className="flex flex-1 flex-col overflow-hidden">
        <TabsList className="w-fit">
          <TabsTrigger value="tenant">{t(T.TAB_TENANT)}</TabsTrigger>
          <TabsTrigger value="organizations">{t(T.TAB_ORGANIZATIONS)}</TabsTrigger>
        </TabsList>

        <TabsContent value="tenant" className="mt-4 min-h-0 flex-1 overflow-y-auto">
          <UsageConfigCard />
        </TabsContent>
        <TabsContent value="organizations" className="mt-4 min-h-0 flex-1">
          <OrganizationUsageConfig />
        </TabsContent>
      </Tabs>
    </main>
  );
};
